import { useQuery } from '@tanstack/react-query';
import { fetchBundleDetailDetails } from './fetchBundleDetailDetails';
import { GlobalReactQueryOptions } from '../../config';
import { browserClient } from '../../react-query';
import { useDispatch } from 'react-redux';
import { receiveBundle } from '../../store/bundle/actions';

const DETAILS_KEY = 'bundleDetailDetails';

export const useBundleDetailDetails = (bundleId: string) => {
    const dispatch = useDispatch();

    return useQuery([DETAILS_KEY, bundleId], () => fetchBundleDetailDetails(bundleId), {
        ...GlobalReactQueryOptions,
        onSuccess: data => {
            // we have to sync the data to the redux store so that the addToList and addToCart actions (from the PriceButton) work
            // in this case the bundleId is required as sourceId in the requests
            dispatch(receiveBundle(data));
        }
    });
};

export const invalidateBundleDetailDetails = (bundleId: string) => {
    return browserClient.invalidateQueries([DETAILS_KEY, bundleId]);
};
